import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';
import { Divider } from '@mui/material';
import Dialog from '../../../../Components/Dialog';
import FormTextField from '../../../../Components/Form/FormTextField';
import {
  CenteredFlexBox,
  ColumnFlexBox,
  FullSizeColumn,
} from '../../../../Components/FlexBox';
import ExtraParamsFormWrapper from './ExtensionDataFormWrapper';
import { useFormContext } from 'react-hook-form';
import { ACTIVITY_TYPES_ICONS } from '../../../../Utils/constants/activityTypes';
import FormCheckbox from '../../../../Components/Form/FormCheckbox';

const DefaultFormContent = function DefaultFormContent({ defaultData }) {
  const {
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();

  useEffect(() => {
    setValue('campaignAdvancement', parseInt(watch('campaignAdvancement'), 10));
  }, [watch('campaignAdvancement')]);

  useEffect(() => {
    if (defaultData?.removeCustomer) {
      setValue('removeCustomer', true);
    }
  }, [defaultData]);

  useEffect(() => {
    if (watch('hasDynamicProgress')) {
      setValue('campaignAdvancement', 0);
    }
  }, [watch('hasDynamicProgress')]);

  return (
    <ColumnFlexBox>
      <CenteredFlexBox gap={2} sx={{ mb: '8px' }}>
        <FormTextField
          allUpperCase
          name="name"
          required
          error={errors?.name}
          defaultValue={defaultData?.name || ''}
        />
        <FormTextField
          allUpperCase
          name="campaignAdvancement"
          type="number"
          disabled={watch('hasDynamicProgress')}
          icon={<PercentRoundedIcon />}
          error={errors?.campaignAdvancement}
          defaultValue={defaultData?.campaignAdvancement || '0'}
        />
      </CenteredFlexBox>
      <FormCheckbox
        name="removeCustomer"
        defaultChecked={defaultData?.removeCustomer || false}
      />
    </ColumnFlexBox>
  );
};

const ActivityOutcomeDialog = function ActivityOutcomeDialog({
  open,
  onClose,
  activityType,
  onSubmit,
  activityTypes,
  defaultData = {},
}) {
  const intl = useIntl();

  const Icon = ACTIVITY_TYPES_ICONS[activityType];

  // Create a unique key based on the data to force remount when data changes
  const dialogKey = defaultData?.id || JSON.stringify(defaultData);

  return (
    <Dialog
      key={dialogKey}
      id={`causal-dialog-${activityType}`}
      open={open}
      onClose={onClose}
      icon={<Icon />}
      title={`${intl.messages[activityType?.toUpperCase()]}`}
      onSubmit={(data) => onSubmit({ ...data, id: defaultData?.id })}
      width="md"
      dividers
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
      form
    >
      <FullSizeColumn>
        <DefaultFormContent defaultData={defaultData} />
        <Divider />
        <ExtraParamsFormWrapper
          activityType={activityType}
          defaultData={defaultData}
          activityTypes={activityTypes}
        />
      </FullSizeColumn>
    </Dialog>
  );
};

export default ActivityOutcomeDialog;
